export default __webpack_public_path__ + "static/media/thankyou.88797dc3.jpg";